const SELECTED_TARGET_STORAGE_KEY = 'designstudio.selectedTargetId';

/** Preferred when nothing is stored and the id is still registered. */
export const PREFERRED_DEFAULT_TARGET_ID = 'marketplace-site';

export type ResolveSelectedTargetIdInput = {
  readonly current: string | undefined;
  readonly stored: string | undefined;
  readonly availableIds: readonly string[];
  readonly preferredDefaultId?: string;
};

export function readStoredSelectedTargetId(): string | undefined {
  const value = window.sessionStorage.getItem(SELECTED_TARGET_STORAGE_KEY);
  if (value === null || value === '') {
    return undefined;
  }
  return value;
}

export function writeStoredSelectedTargetId(targetId: string): void {
  window.sessionStorage.setItem(SELECTED_TARGET_STORAGE_KEY, targetId);
}

export function resolveSelectedTargetId(input: ResolveSelectedTargetIdInput): string | undefined {
  if (input.current !== undefined && input.availableIds.includes(input.current)) {
    return input.current;
  }
  if (input.stored !== undefined && input.availableIds.includes(input.stored)) {
    return input.stored;
  }
  const preferred = input.preferredDefaultId ?? PREFERRED_DEFAULT_TARGET_ID;
  if (input.availableIds.includes(preferred)) {
    return preferred;
  }
  return undefined;
}
